var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.51 92.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2f519e;\n      }\n\n      .cls-2 {\n        fill: #2d91ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.32,81.93C8.2,81.93,0,73.73,0,63.61s8.2-18.32,18.32-18.32,18.32,8.2,18.32,18.32c0,24.03-29.32,28.7-29.32,28.7l-1.73-6.44s3-1.26,5.56-3.94c0,0,7.17,0,7.17,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.32,
    cy: 18.32,
    r: 18.32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.24,26.37h10.09v5.97c3.1-4.11,7.37-6.59,12.57-6.59h1.47v10.4h-1.47c-8.07,0-12.57,4.27-12.57,10.94v18.85h-10.09V26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.44,46.15c0-11.79,9.15-20.71,21.26-20.71s21.26,8.92,21.26,20.87c0,1.09-.08,2.33-.31,3.34h-31.42c1.32,5.12,5.43,8.46,10.86,8.46,4.11,0,7.52-1.86,9.31-4.42h10.94c-3.03,7.83-10.86,13.19-20.48,13.19-12.26,0-21.41-8.92-21.41-20.71ZM111.3,42.27h20.87c-1.24-4.81-5.27-8.07-10.47-8.07s-9,3.18-10.4,8.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.83,10.08h10.09v20.95c3.18-3.49,7.6-5.59,12.88-5.59,11.02,0,19.24,8.92,19.24,20.71s-8.22,20.71-19.24,20.71c-5.27,0-9.7-2.09-12.88-5.59v4.65h-10.09V10.08ZM205.63,46.15c0-6.21-4.58-10.94-10.86-10.94s-10.86,4.73-10.86,10.94,4.65,10.94,10.86,10.94,10.86-4.73,10.86-10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.66,46.15c0-11.79,9.15-20.71,21.26-20.71s21.26,8.92,21.26,20.71-9.15,20.71-21.26,20.71-21.26-8.92-21.26-20.71ZM254.78,46.15c0-6.21-4.58-10.94-10.86-10.94s-10.86,4.73-10.86,10.94,4.65,10.94,10.86,10.94,10.86-4.73,10.86-10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.98,26.37h10.09v5.97c3.1-4.11,7.37-6.59,12.57-6.59h1.47v10.4h-1.47c-8.07,0-12.57,4.27-12.57,10.94v18.85h-10.09V26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.59,26.37h10.09v4.42c3.1-3.49,7.45-5.35,12.57-5.35,9.31,0,15.44,6.05,15.44,15.36v12.02c0,2.09,1.24,3.34,3.34,3.34h.85v9.77h-2.87c-7.52,0-11.4-3.72-11.4-10.94v-10.94c0-5.35-3.41-8.84-8.61-8.84-5.59,0-9.31,3.57-9.31,9v21.72h-10.09V26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.53,53.91v-18.31h-6.28v-9.23h3.57c2.09,0,3.26-1.09,3.26-3.18v-7.37h9.54v10.55h12.88v9.23h-12.88v17.3c0,2.33,1.55,3.8,3.88,3.8s3.96-1.71,3.96-4.5h9c0,8.38-5.35,13.73-13.65,13.73s-13.27-4.81-13.27-12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.76,46.15c0-11.79,8.3-20.71,19.32-20.71,5.27,0,9.7,2.09,12.88,5.59v-4.65h10.09v26.45c0,2.09,1.16,3.34,3.34,3.34h.78v9.77h-2.87c-5.43,0-8.92-1.94-10.47-5.74-3.18,4.11-7.99,6.67-13.73,6.67-11.02,0-19.32-8.92-19.32-20.71ZM421.95,46.15c0-6.21-4.65-10.94-10.94-10.94s-10.86,4.73-10.86,10.94,4.65,10.94,10.86,10.94,10.94-4.73,10.94-10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.79,54.22V10.08h10.09v41.97c0,2.56,1.55,4.11,4.34,4.11h2.4v9.77h-3.88c-8.53,0-12.96-4.03-12.96-11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.72,10.08h10.09v32.81l15.36-16.52h12.72l-16.6,17.61,17.22,21.95h-12.96l-11.25-14.58-4.5,4.73v9.85h-10.09V10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.39,62.91c-3.75,0-6.79-3.04-6.79-6.79s3.04-6.79,6.79-6.79,6.79,3.04,6.79,6.79c0,8.9-10.86,10.63-10.86,10.63l-.64-2.39s1.33-.54,2.41-1.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 158.39,
    cy: 33.9,
    r: 6.79
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf7d1f09115b684887f3034c63e3e5f7.svg";
export { ForwardRef as ReactComponent };